import { Component } from '@theme/component';

class VolumePricingInfoComponent extends Component {

  connectedCallback() {
    super.connectedCallback();
    const anchoredPopover = this.closest('anchored-popover-component');
    if (anchoredPopover instanceof Component && anchoredPopover.isConnected) {
      try {
        anchoredPopover.updatedCallback();
      } catch (error) {
        Promise.resolve().then(() => {
          if (anchoredPopover.isConnected) {
            try {
              anchoredPopover.updatedCallback();
            } catch (e) {}
          }
        });
      }
    }
  }

  updatedCallback() {
    super.updatedCallback();
    const anchoredPopover = this.closest('anchored-popover-component');
    if (anchoredPopover instanceof Component) {
      anchoredPopover.updatedCallback();
    }
  }

  updateActiveTier(quantity) {
    const anchoredPopover = this.closest('anchored-popover-component');
    const popover = anchoredPopover instanceof Component ? anchoredPopover.refs?.popover : null;
    const rows = popover?.querySelectorAll('.volume-pricing-info__row[data-quantity]');
    if (!rows) return;

    let activeTier = null;
    for (const row of rows) {
      row.classList.remove('volume-pricing-info__row--active');
      if (row instanceof HTMLElement && quantity >= parseInt(row.dataset.quantity || '0')) {
        activeTier = row;
      }
    }
    activeTier?.classList.add('volume-pricing-info__row--active');
  }
}

async function registerVolumePricingInfo() {

  await customElements.whenDefined('anchored-popover-component');

  if (!customElements.get('volume-pricing-info')) {
    customElements.define('volume-pricing-info', VolumePricingInfoComponent);
  }
}

registerVolumePricingInfo();
